import type * as THREE from 'three';

// Mutable Three.js object references shared across modules (reassigned in one
// module, read in another). Kept separate from `state` so state.ts stays free
// of a Three.js import.
export const refs = {
  coverTex: null as THREE.Texture | null,
  bookGroup: null as THREE.Group | null,
  backdropTex: null as THREE.Texture | null,
};
